import React, { Component } from "react";
import renderHTML from "react-render-html";

import "./description.css";

class Description extends Component {
  render() {
    return (
      <div className="description">
        <div>{renderHTML(this.props.description)}</div>
      </div>
    );
  }
}

export default Description;
